<template>
    <div style="padding: 10px" class="label_title">
        <label
            class="label_title"
            style="margin-bottom: 10px; display: block; font-weight: 700;"
            :for="question.label"
        >
            <p style="vertical-align: inherit;">
                {{ question.label }}
            </p>
        </label>
        <component
            :is="`${question.type}-question`"
            :question="question"
            :class="{ 'is-invalid': !!error }"
            @input="$emit('input', $event)"
        />
        <div style="color: red; margin-top: 5px;">
            {{ error }}
        </div>
    </div>
</template>

<script>
import types from './types';

export default {
    components: {
        ...types
    },

    props: {
        question: {
            type: Object,
            required: true
        },
        validation: {
            type: Object,
            required: true
        }
    },

    computed: {
        error() {
            const {
                $error,
                required,
                isFormatValid,
                email,
                correctQuantity
            } = this.validation;

            if (!$error) {
                return '';
            }

            if (!required) {
                return 'אסור להשאיר ריק!';
            }

            if (!isFormatValid) {
                return 'סוג קובץ לא חוקי!';
            }

            if (!email) {
                return 'כתובת דוא"ל לא תקינה!';
            }

            if (!correctQuantity) {
                return `מוכרח להיות פה משהו`;
            }

            return 'Something is wrong... 🤔';
        }
    }
};
</script>
